import $ from 'jquery';
import Masonry from 'masonry-layout';
import { Fancybox } from "@fancyapps/ui";

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import './../../scss/blocks/block-grid-gallery.scss';

let msnry = null;
$(document).ready(function() {
  Fancybox.bind("[data-fancybox]", {
  });
  if (window.innerWidth > 768) {
    const grid = document.querySelector('.masonry-grid');
    if (grid) {
      msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
      });
    }
  }     
  
});

$(window).on("resize", function(event){
  const grid = document.querySelector('.masonry-grid');

  if (window.innerWidth > 768 && !msnry && grid) {
    msnry = new Masonry(grid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  } else if (window.innerWidth <= 768 && msnry) {
    msnry.destroy();
    msnry = null;
  }
});